import { ModerationComment, PromptStatus } from '@ai-platform/ai-utils';

import { StepStatus } from '../../components/UI/Steps/Steps.types';
import { Step } from '../../components/UI/Steps/Steps.types';

/**
 * Массивы фраз для разных причин отклонения/отложения промпта
 */
const STATUS_MESSAGES = {
    // Общие фразы для статуса "отложен" (по умолчанию)
    [ModerationComment.Later]: [
        'Этот промпт опередил своё время. Мы добавим его, когда на Промптхабе появятся нужные функции',
        'Классный промпт, но на Промптхабе пока нет для него условий. Скоро доработаем платформу и добавим его.',
        'К сожалению, мы пока не можем добавить ваш промпт на Промптхаб. Скоро доработаем платформу и добавим его.',
    ],
} as const;

/**
 * Возвращает случайную фразу из массива сообщений о статусе в зависимости от комментария модератора
 * @param moderationComment - комментарий модератора (опционально)
 * @returns случайная фраза, соответствующая причине отклонения/отложения
 */
export const getRandomPhrase = (moderationComment?: ModerationComment): string => {
    const messages =
        STATUS_MESSAGES[moderationComment || ModerationComment.Later] ?? STATUS_MESSAGES[ModerationComment.Later];
    const randomIndex = Math.floor(Math.random() * messages.length);

    return messages[randomIndex];
};

/**
 * Возвращает полный объект шага для третьего шага (публикация/отклонена) в зависимости от статуса промпта
 * @param promptStatus - статус промпта
 * @returns объект шага
 */
export const getPublicationStep = (promptStatus: PromptStatus | undefined): Step => {
    if (promptStatus === PromptStatus.Rejected) {
        return {
            text: 'Отклонена',
            status: StepStatus.Error,
            icon: 'close',
        };
    }
    if (promptStatus === PromptStatus.Postponed) {
        return {
            text: 'Отложена',
            status: StepStatus.Error,
            icon: 'info',
            iconColor: '#ff5e00',
        };
    }

    return {
        text: 'Публикация',
        status: StepStatus.Inactive,
        icon: 'tick',
    };
};

/**
 * Возвращает статус для второго шага (модерация) в зависимости от статуса промпта
 * @param promptStatus - статус промпта
 * @returns статус шага модерации
 */
export const getModerationStepStatus = (promptStatus: PromptStatus | undefined): StepStatus => {
    return promptStatus === PromptStatus.Rejected || promptStatus === PromptStatus.Postponed
        ? StepStatus.Done
        : StepStatus.Pending;
};
